

import styles from './login.module.css';
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTripInfo } from '../context';
import { API_URL } from '../utils/fatch';



import { LoginSignUpForm } from './log-sinup-form2';



export function Login() {
    const { setLoggedIn, setAdminControl, setRedirectFromSignup } = useTripInfo();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // A share link sends people here to sign in and then hands them straight
    // back to the invite so they can finish joining the trip.
    const returnTo = searchParams.get('returnTo');
    const [loading, setLoading] = useState(false);
    const [adminControls, setAdminControls] = useState(false);
    const [error, setError] = useState({
        hasError: false,
        message: ''
    });
    const [success, setSuccess] = useState(false);
    const [notSuccess, setNotSuccess] = useState({
        wasntSuccess: false,
        message: ''
    });

    useEffect(() => {
        document.title = "Login";
        //document.body.classList.add(styles.loginBody);
        return () => {
           // document.body.classList.remove(styles.loginBody);
        };
    }, []);

    /*     useEffect(() => {
           if(loggedIn){
            navigate('/add_expense');
              
           }
        }, [loggedIn]); */




    const handleLogin = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError({ hasError: false, message: null });
        setSuccess(false);
        setNotSuccess({
            wasntSuccess: false,
            message: null
        });

        const email = event.target.username.value;
        const password = event.target.password.value;

        try {


            const response = await fetch(API_URL + '/login', {
                method: 'POST', // Use 'POST' for login
                credentials: 'include', // ✅ Required for cookies

                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });


            if (!response.ok) {

                const data = await response.json();
                console.log(data);
                setNotSuccess({
                    wasntSuccess: true,
                    message: data.message
                });
                setSuccess(false);
                setError({ hasError: false, message: null });
                return;

            }

            const data = await response.json();

            console.log('Login successful:', data);


            setSuccess(true);
            setNotSuccess({
                wasntSuccess: false,
                message: null
            });
            setError({ hasError: false, message: null });
            // Redirect to dashboard or another page
            setAdminControl(data.user.admin);
            if (data.user.admin) {
                setAdminControls(true);

            } else {
                setAdminControls(false);


                setLoggedIn(true);
                navigate(returnTo || '/add_expense');
            }


        } catch (error) {
            console.error('Login failed:', error);
            setError({ hasError: true, message: error?.message || 'Something went wrong.' });
            setNotSuccess({
                wasntSuccess: false,
                message: null
            });
            setSuccess(false);

        } finally {

            setLoading(false);


        }
    }


    return (<>
        {console.log(adminControls)}

        {adminControls ? <>
            <div>
                <h2 className={styles.adminHeader}>Where do you want to continue?</h2>
                <div className={styles.adminButtonsContainer}>
                    <button className={styles.adminButton} onClick={() => {

                        setRedirectFromSignup(true);
                        setLoggedIn(true);
                        navigate('/admin');
                    }

                    }>Admin Dashboard</button>
                    <button className={styles.adminButton} onClick={() => {
                        navigate('/add_expense');
                        setLoggedIn(true);

                    }}>User Dashboard</button>
                </div>
            </div>

        </> :
           <LoginSignUpForm type="login" loading={loading} handleLogin={handleLogin} error={error} success={success} notSuccess={notSuccess} />  

            }
    </>
    );
}




